import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "header-top" }
const _hoisted_4 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_6 = { class: "header-secondary" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 773.292 144.122",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 773.292 144.122",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_10 = { class: "header-bottom" }
const _hoisted_11 = { class: "header-primary" }
const _hoisted_12 = {
  key: 0,
  class: "alert-container"
}
const _hoisted_13 = {
  key: 0,
  class: "header-drawer"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "header-drawer-item header-drawer-secondary"
}
const _hoisted_16 = { class: "header-drawer-footer" }
const _hoisted_17 = ["lang"]
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RhAlert = _resolveComponent("RhAlert")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: "#",
          class: "header-hamburger",
          title: "Header hamburger menu",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["prevent"]))
        }, [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("path", { d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("path", { d: "M4 27h28v-3H4v3zm0-8h28v-3H4v3zM4 8v3h28V8H4z" }, null, -1)
              ]))]))
        ]),
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, [
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: _ctx.homePage }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.LOGOUT && _ctx.LOGOUT(...args))),
                      lang: "en"
                    }, _toDisplayString(_ctx.$t("general.logout")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNavigationType('secondary'), (nav) => {
            return (_openBlock(), _createElementBlock("li", {
              key: nav.name
            }, [
              _createElementVNode("a", {
                href: nav.link
              }, _toDisplayString(nav.title), 9, _hoisted_7)
            ]))
          }), 128))
        ]),
        (_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              "aria-label": "logo",
              to: { name: _ctx.logoPath },
              class: "header-logo",
              title: "Rhenus Home Delivery"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("path", {
                    class: "st0",
                    fill: "#fff",
                    d: "M90.864 73.26l40.802-38.29H91.443L50.51 73.26h40.355zM101.712 109.17l29.724-27.996H42.073l-29.93 27.997h89.569z"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st1",
                    d: "M8.21 8.21v127.674h127.674V8.21H8.21zM0 0h144.094v144.094H0V0z",
                    fill: "#fff",
                    "fill-rule": "evenodd"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st0",
                    fill: "#fff",
                    d: "M268.561.028h18.182V27.28h56.62V.028h18.174v71.748h-18.174V44.573h-56.62v27.203h-18.182V.028zM466.07.028h-94.644v71.748h94.643V54.53h-76.461v-9.957h72.185V27.28h-72.185v-9.956h76.461V.028zM546.676 71.776l-54.675-49.642v49.642H473.82V.082h21.388l54.37 49.345V.027h18.183v71.749h-21.084zM670.6.028v53.329c0 10.172-8.412 18.419-18.788 18.419H594.51c-10.377 0-18.787-8.247-18.787-18.42V.029h18.181v48.56c0 3.281 2.713 5.942 6.061 5.942h46.391c3.347 0 6.06-2.66 6.06-5.942V.028H670.6zM750.573 71.776c12.547 0 22.719-9.923 22.719-22.224 0-12.3-10.172-22.272-22.719-22.272h-49.615c-2.878 0-5.211-2.288-5.211-5.11 0-2.821 2.333-4.846 5.211-4.846h69.783V.028h-70.155c-12.547 0-22.718 9.971-22.718 22.273 0 12.3 10.17 22.272 22.718 22.272H750.2c2.878 0 5.212 2.288 5.212 5.11 0 2.821-2.333 4.847-5.212 4.847h-70.818v17.246h71.19z"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st1",
                    d: "M185.726 44.618v27.158h-18.182V.028h71.204c12.547 0 22.718 9.971 22.718 22.273 0 12.3-10.171 22.317-22.718 22.317h-5.591l27.462 27.158h-25.504l-27.556-27.158h-21.833zm0-17.338v-9.956h52.501c2.805 0 5.078 2.228 5.078 4.977 0 2.75-2.273 4.979-5.078 4.979h-52.5z",
                    fill: "#fff",
                    "fill-rule": "evenodd"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st0",
                    d: "M632.94 143.845c-4.585 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.771-8.579 8.356-8.579h54.331l.047 9.117h-48.497c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h48.497l-.047 8.853H632.94zM706.82 144.062v-9.145h49.365c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.451-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.889v9.182h-48.62c-2.838 0-5.406 2.062-5.406 5.156 0 2.984 2.451 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.553 14.396-14.715 14.396H706.82zM574.862 104.674h-23.52l.008 39.388h-9.823l-.007-39.363-23.5-.105v-9.119h56.842v9.199zM593.273 95.475h9.803v48.587h-9.803V95.475zM439.39 144.062v-9.145h49.366c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.452-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.888v9.182h-48.62c-2.837 0-5.405 2.062-5.405 5.156 0 2.984 2.45 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.552 14.396-14.715 14.396H439.39zM409.052 95.475h9.804v48.587h-9.804V95.475zM167.135 95.535h9.82l.007 39.367 52.08.106v9.114h-61.81l-.097-48.587zM260.931 104.588h-5.436c-2.458 0-4.395 2.028-4.395 4.462v21.48c0 2.434 1.937 4.463 4.395 4.463h34.264c2.458 0 4.396-2.03 4.396-4.463v-21.48c0-2.434-1.938-4.462-4.396-4.462h-28.828zm.064 39.257h-11.381c-4.584 0-8.357-3.81-8.357-8.58V104.05c0-4.77 3.773-8.579 8.357-8.579h46.026c4.585 0 8.357 3.81 8.357 8.58v31.215c0 4.769-3.772 8.58-8.357 8.58h-34.645zM344.378 134.993h26.865c2.458 0 4.395-2.03 4.395-4.463v-2.377c0-2.433-1.937-4.462-4.395-4.462h-23.946l.048-9.116h29.779c4.584 0 8.356 3.81 8.356 8.58v12.11c0 4.77-3.772 8.58-8.356 8.58h-46.362c-4.584 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.772-8.579 8.356-8.579l54.545.062v9.055h-48.663c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h7.734z",
                    fill: "#fff"
                  }, null, -1)
                ]))]))
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              "aria-label": "logo",
              to: { name: _ctx.homePage },
              class: "header-logo"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("path", {
                    class: "st0",
                    fill: "#fff",
                    d: "M90.864 73.26l40.802-38.29H91.443L50.51 73.26h40.355zM101.712 109.17l29.724-27.996H42.073l-29.93 27.997h89.569z"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st1",
                    d: "M8.21 8.21v127.674h127.674V8.21H8.21zM0 0h144.094v144.094H0V0z",
                    fill: "#fff",
                    "fill-rule": "evenodd"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st0",
                    fill: "#fff",
                    d: "M268.561.028h18.182V27.28h56.62V.028h18.174v71.748h-18.174V44.573h-56.62v27.203h-18.182V.028zM466.07.028h-94.644v71.748h94.643V54.53h-76.461v-9.957h72.185V27.28h-72.185v-9.956h76.461V.028zM546.676 71.776l-54.675-49.642v49.642H473.82V.082h21.388l54.37 49.345V.027h18.183v71.749h-21.084zM670.6.028v53.329c0 10.172-8.412 18.419-18.788 18.419H594.51c-10.377 0-18.787-8.247-18.787-18.42V.029h18.181v48.56c0 3.281 2.713 5.942 6.061 5.942h46.391c3.347 0 6.06-2.66 6.06-5.942V.028H670.6zM750.573 71.776c12.547 0 22.719-9.923 22.719-22.224 0-12.3-10.172-22.272-22.719-22.272h-49.615c-2.878 0-5.211-2.288-5.211-5.11 0-2.821 2.333-4.846 5.211-4.846h69.783V.028h-70.155c-12.547 0-22.718 9.971-22.718 22.273 0 12.3 10.17 22.272 22.718 22.272H750.2c2.878 0 5.212 2.288 5.212 5.11 0 2.821-2.333 4.847-5.212 4.847h-70.818v17.246h71.19z"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st1",
                    d: "M185.726 44.618v27.158h-18.182V.028h71.204c12.547 0 22.718 9.971 22.718 22.273 0 12.3-10.171 22.317-22.718 22.317h-5.591l27.462 27.158h-25.504l-27.556-27.158h-21.833zm0-17.338v-9.956h52.501c2.805 0 5.078 2.228 5.078 4.977 0 2.75-2.273 4.979-5.078 4.979h-52.5z",
                    fill: "#fff",
                    "fill-rule": "evenodd"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "st0",
                    d: "M632.94 143.845c-4.585 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.771-8.579 8.356-8.579h54.331l.047 9.117h-48.497c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h48.497l-.047 8.853H632.94zM706.82 144.062v-9.145h49.365c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.451-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.889v9.182h-48.62c-2.838 0-5.406 2.062-5.406 5.156 0 2.984 2.451 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.553 14.396-14.715 14.396H706.82zM574.862 104.674h-23.52l.008 39.388h-9.823l-.007-39.363-23.5-.105v-9.119h56.842v9.199zM593.273 95.475h9.803v48.587h-9.803V95.475zM439.39 144.062v-9.145h49.366c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.452-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.888v9.182h-48.62c-2.837 0-5.405 2.062-5.405 5.156 0 2.984 2.45 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.552 14.396-14.715 14.396H439.39zM409.052 95.475h9.804v48.587h-9.804V95.475zM167.135 95.535h9.82l.007 39.367 52.08.106v9.114h-61.81l-.097-48.587zM260.931 104.588h-5.436c-2.458 0-4.395 2.028-4.395 4.462v21.48c0 2.434 1.937 4.463 4.395 4.463h34.264c2.458 0 4.396-2.03 4.396-4.463v-21.48c0-2.434-1.938-4.462-4.396-4.462h-28.828zm.064 39.257h-11.381c-4.584 0-8.357-3.81-8.357-8.58V104.05c0-4.77 3.773-8.579 8.357-8.579h46.026c4.585 0 8.357 3.81 8.357 8.58v31.215c0 4.769-3.772 8.58-8.357 8.58h-34.645zM344.378 134.993h26.865c2.458 0 4.395-2.03 4.395-4.463v-2.377c0-2.433-1.937-4.462-4.395-4.462h-23.946l.048-9.116h29.779c4.584 0 8.356 3.81 8.356 8.58v12.11c0 4.77-3.772 8.58-8.356 8.58h-46.362c-4.584 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.772-8.579 8.356-8.579l54.545.062v9.055h-48.663c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h7.734z",
                    fill: "#fff"
                  }, null, -1)
                ]))]))
              ]),
              _: 1
            }, 8, ["to"]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterNavigation(_ctx.navigation, _ctx.isLoggedIn, _ctx.currentLocale), (nav) => {
            return (_openBlock(), _createElementBlock("li", {
              key: nav.name
            }, [
              _createVNode(_component_router_link, {
                id: nav.title,
                to: { name: nav.name },
                exact: nav.exactActiveLink,
                lang: nav.name && nav.name.includes('faq') ? 'en' : null
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(nav.title), 1)
                ]),
                _: 2
              }, 1032, ["id", "to", "exact", "lang"])
            ]))
          }), 128))
        ])
      ])
    ]),
    (!!_ctx.alertMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_RhAlert, {
            type: "info",
            onClick: _cache[2] || (_cache[2] = () => (_ctx.alertMessage = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.alertMessage), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("ul", {
                class: "header-drawer-navigation",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpen = false))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterNavigation(_ctx.navigation, _ctx.isLoggedIn, _ctx.currentLocale), (nav) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: nav.name,
                    class: "header-drawer-item header-drawer-primary"
                  }, [
                    _createVNode(_component_router_link, {
                      class: "header-drawer-link",
                      to: { name: nav.name },
                      lang: nav.name && nav.name.includes('faq') ? 'en' : null
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(nav.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "lang"])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNavigationType('secondary'), (nav) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: nav.name,
                    class: "header-drawer-item header-drawer-secondary"
                  }, [
                    _createElementVNode("a", {
                      href: nav.link
                    }, _toDisplayString(nav.title), 9, _hoisted_14)
                  ]))
                }), 128)),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        class: "header-drawer-link"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.LOGOUT && _ctx.LOGOUT(...args))),
                            lang: "en"
                          }, _toDisplayString(_ctx.$t("general.logout")), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("ul", {
                  class: "header-drawer-footer-list",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpen = false))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileFooter, (footer) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: footer.name,
                      lang: footer.name && footer.name.includes('faq') ? 'en' : null
                    }, [
                      (footer.url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: footer.url,
                            target: "_blank"
                          }, _toDisplayString(footer.title), 9, _hoisted_18))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { name: footer.name }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(footer.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                    ], 8, _hoisted_17))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}